<template>
	<div class="home-durante-container container-fluid p-2 p-md-3">

		<div class="row">
			<div class="col-12 col-lg-8 order-1 order-lg-1 mt-2 mt-lg-0">

		  		<!-- WIDGET DE NOTIFICAÇÃO GLOBAL -->
		  		<div class="janelaNotificacao d-flex align-items-center p-3 mt-3 clickable" v-if="notificacao"
		       			:style="`border-left: 4px solid ${getEstiloNotificacao(notificacao.tipoEvento).borda}; background-color: ${getEstiloNotificacao(notificacao.tipoEvento).fundo};`" @click="irParaNotificacao">
		    		<div class="mr-3 d-flex align-items-center justify-content-center" 
		         		:style="`width: 40px; height: 40px; border-radius: 50%; background-color: ${getEstiloNotificacao(notificacao.tipoEvento).fundoIcone}; color: ${getEstiloNotificacao(notificacao.tipoEvento).borda};`">
		      			<i :class="getEstiloNotificacao(notificacao.tipoEvento).icone" class="fa-lg"></i>
		    		</div>
		    		<div class="flex-grow-1 text-left">
		      			<div class="font-weight-bold" style="color: #333; font-size: 14px;">{{ notificacao.mensagem }}</div>
		      			<div style="color: #777; font-size: 11px; margin-top: 2px;">
		        			<strong>Em</strong> {{ notificacao.dataCriacao }}
		      			</div>
		    		</div>
		  		</div>

				<!--
					<div class="col-12 mb-3 text-center fraseInicio">
						"Enquanto houver partida, haverá esperança!"
					</div>
				-->

				<div class="row mb-3 mt-3">
					<div
						class="col-12"
						:class="classePartidaAnterior"
						v-for="partida in partidasAnteriores"
						:key="partida.id">

						<div class="janelaPartida clickable mb-3 mb-md-0" @click="detalharPartida(partida.id)">
							<div class="col fonte-minima">
								<i class="fas fa-futbol mr-1"></i> Jogo Anterior
							</div>
							<div class="row m-1 ml--1">
								<div class="text-left alinhaVert">
									<img width="15" class="ml-3 mt--2" :src="partida.selecaoA.imagem">
								</div>
								<div class="col text-left font-weight-bold fonte-minima">
									{{partida.selecaoA.nome}}
								</div>
								<div class="col-1 mr-2 alinhaVert font-weight-bold fonte-minima">
									{{partida.placarA}}
								</div>
							</div>
							<div class="row m-1 ml--1">
								<div class="text-left alinhaVert">
									<img width="15" class="ml-3 mt--2" :src="partida.selecaoB.imagem">
								</div>
								<div class="col text-left font-weight-bold fonte-minima">
									{{partida.selecaoB.nome}}
								</div>
								<div class="col-1 mr-2 alinhaVert font-weight-bold fonte-minima">
									{{partida.placarB}}
								</div>
							</div>
						</div>

					</div>
				</div>

				<div class="janelaPartida mb-3" 
						:class="(partida1.iniciada) ? 'aovivo': ''"
						v-if="partida1 != null">
					<div class="row">
						<div class="col">
							<div class="tituloJanelaPequena ml-2" v-if="partida1.iniciada">
								<i class="fas fa-futbol mr-1"></i> Jogo rolando
							</div>
							<div class="tituloJanelaPequena ml-2" v-else>
								<i class="fas fa-futbol mr-1"></i> Próxima partida
							</div>
						</div>
						<div class="col-auto" v-if="partida1.iniciada">
							<div class="ml-2 mt-1">
								<span class="tagAoVivo"> <i class="fas fa-wifi mr-1"></i> AO VIVO</span>
							</div>
						</div>
					</div>
					<div class="row mt-2">
						<div class="col text-center">
							<div class="d-flex flex-wrap justify-content-center gap-1">
								<div class="badge badge-secondary mb-1"><i class="fas fa-calendar-alt"></i>&nbsp; {{ partida1.dataHoraFmt.substring(0, 5) }} </div>
								<div class="badge badge-secondary mb-1"><i class="far fa-clock"></i>&nbsp; {{ partida1.dataHoraFmt.substring(6, 8) }}h </div>
								<div class="badge badge-secondary mb-1 text-truncate" style="max-width: 200px;"><i class="fas fa-map-marker-alt"></i>&nbsp; {{ partida1.local }}</div>
							</div>
						</div>
					</div>
                    <div class="row m-2 mt-3 align-items-center">
						<div class="col-12 col-md-4 text-center text-md-left mb-2 mb-md-0">
							<div class="d-flex align-items-center justify-content-center justify-content-md-start flex-wrap">
								<img width="30" class="mb-1 mb-md-0" :src="partida1.selecaoA.imagem">
								<span class="font-weight-bold fonte-time ml-2">{{partida1.selecaoA.nome}}</span>
							</div>
						</div>
						<div class="col-12 col-md-4 text-center mb-2 mb-md-0">
							<div class="font-weight-bold fonte-placar">
								{{partida1.placarA}} x {{partida1.placarB}}
							</div>
						</div>
						<div class="col-12 col-md-4 text-center text-md-right">
							<div class="d-flex align-items-center justify-content-center justify-content-md-end flex-wrap">
								<span class="font-weight-bold fonte-time mr-2">{{partida1.selecaoB.nome}}</span>
								<img width="30" class="mb-1 mb-md-0" :src="partida1.selecaoB.imagem">
							</div>
						</div>
					</div>
					<!--
					<div class="row m-2 mt--3">
						<div class="col-6 text-left alinhaVert font-weight-bold fonte-media">
							{{partida1.selecaoA.nome}}
						</div>
						<div class="col-6 text-right alinhaVert font-weight-bold fonte-media">
							{{partida1.selecaoB.nome}}
						</div>
					</div>
					-->
					<div class="row m-2">
						<div class="col text-center">
							<button type="button"  @click="detalharPartida(partida1.id)"
									class="btn btn-outline-secondary btn-sm btn-block-xs">
								<i class="fas fa-eye mr-1"></i> Detalhes da Partida
							</button>
						</div>
					</div>
					<div class="row m-2 d-none d-md-flex">
						<div class="col-4">
							<div class="font-weight-bold fonte-minima" :style="`color: `+ partida1.selecaoA.cor +`;`"> {{ partida1.selecaoA.nome }}: {{ partida1.aposta.porcSelecaoA }}% ({{partida1.aposta.numSelecaoA}}) </div>
						</div>
						<div class="col-4">
							<div class="text-center font-weight-bold fonte-minima" style="color: #4d4d4a;"> Empate: {{ partida1.aposta.porcEmpate }}% ({{partida1.aposta.numEmpate}}) </div>
						</div>
						<div class="col-4">
							<div class="text-right font-weight-bold fonte-minima" :style="`color: `+ partida1.selecaoB.cor +`;`"> {{ partida1.selecaoB.nome }}: {{ partida1.aposta.porcSelecaoB }}% ({{partida1.aposta.numSelecaoB}}) </div>
						</div>
					</div>
					<div class="row m-2 d-md-none">
						<div class="col-12 mb-1">
							<div class="font-weight-bold fonte-minima text-center" :style="`color: `+ partida1.selecaoA.cor +`;`"> {{ partida1.selecaoA.nome }}: {{ partida1.aposta.porcSelecaoA }}% ({{partida1.aposta.numSelecaoA}}) </div>
						</div>
						<div class="col-12 mb-1">
							<div class="text-center font-weight-bold fonte-minima" style="color: #4d4d4a;"> Empate: {{ partida1.aposta.porcEmpate }}% ({{partida1.aposta.numEmpate}}) </div>
						</div>
						<div class="col-12 mb-1">
							<div class="text-center font-weight-bold fonte-minima" :style="`color: `+ partida1.selecaoB.cor +`;`"> {{ partida1.selecaoB.nome }}: {{ partida1.aposta.porcSelecaoB }}% ({{partida1.aposta.numSelecaoB}}) </div>
						</div>
					</div>
					<div class="row m-2">
						<div class="col">
							<div class="row">
								<div class="barraPorcentagem" :style="`background-color: `+ partida1.selecaoA.cor +`; width: `+ partida1.aposta.porcSelecaoA +`%`"> </div>
								<div class="barraPorcentagem" :style="`background-color: #a4a4a2; width: `+ partida1.aposta.porcEmpate +`%`"> </div>
								<div class="barraPorcentagem" :style="`background-color: `+ partida1.selecaoB.cor +`; width: `+ partida1.aposta.porcSelecaoB +`%`"> </div>
							</div>
						</div>
					</div>
				</div>
				
				<div class="row mt-3">
					<div class="col-12 col-md-6 mb-3 mb-md-0">

						<div class="janelaPartida" v-if="partida2 != null">
							<div class="row">
								<div class="col tituloQuadroPequeno">
									<i class="fas fa-futbol ml-1"></i> Jogo Seguinte
								</div>
							</div>
							<div class="row">
								<div class="col text-center">
									<div class="d-flex flex-wrap justify-content-center gap-1 mt-2">
										<div class="badge badge-secondary mb-1"><i class="fas fa-calendar-alt"></i>&nbsp; {{ partida2.dataHoraFmt.substring(0, 5) }} </div>
										<div class="badge badge-secondary mb-1"><i class="far fa-clock"></i>&nbsp; {{ partida2.dataHoraFmt.substring(6, 8) }}h </div>
										<div class="badge badge-secondary mb-1 text-truncate" style="max-width: 150px;"><i class="fas fa-map-marker-alt"></i>&nbsp; {{ partida2.local }}</div>
									</div>
								</div>
							</div>
							<div class="row m-2 mt-2">
								<div class="col-4 text-center">
									<img width="20" class="mb-1" :src="partida2.selecaoA.imagem">
									<div class="font-weight-bold fonte-pequena text-truncate">{{partida2.selecaoA.nome}}</div>
								</div>
								<div class="col-4 text-center font-weight-bold fonte-pequena d-flex align-items-center justify-content-center">
									x
								</div>
								<div class="col-4 text-center">
									<img width="20" class="mb-1" :src="partida2.selecaoB.imagem">
									<div class="font-weight-bold fonte-pequena text-truncate">{{partida2.selecaoB.nome}}</div>
								</div>
							</div>
							<div class="row">
								<div class="col text-center">
									<button type="button" @click="detalharPartida(partida2.id)"
											class="btn btn-outline-secondary btn-sm">
										<i class="fas fa-eye mr-1"></i> Ver Partida
									</button>
								</div>
							</div>
							<div class="row m-2">
								<div class="col-4">
									<div class="font-weight-bold fonte-minima" :style="`color: `+ partida2.selecaoA.cor +`;`"> {{ partida2.aposta.porcSelecaoA }}% ({{partida2.aposta.numSelecaoA}}) </div>
								</div>
								<div class="col-4">
									<div class="text-center font-weight-bold fonte-minima" style="color: #4d4d4a;"> {{ partida2.aposta.porcEmpate }}% ({{partida2.aposta.numEmpate}}) </div>
								</div>
								<div class="col-4">
									<div class="text-right font-weight-bold fonte-minima" :style="`color: `+ partida2.selecaoB.cor +`;`"> {{ partida2.aposta.porcSelecaoB }}% ({{partida2.aposta.numSelecaoB}}) </div>
								</div>
							</div>
							<div class="row m-2">
								<div class="col">
									<div class="row">
										<div class="barraPorcentagem" :style="`background-color: `+ partida2.selecaoA.cor +`; width: `+ partida2.aposta.porcSelecaoA +`%`"> </div>
										<div class="barraPorcentagem" :style="`background-color: #a4a4a2; width: `+ partida2.aposta.porcEmpate +`%`"> </div>
										<div class="barraPorcentagem" :style="`background-color: `+ partida2.selecaoB.cor +`; width: `+ partida2.aposta.porcSelecaoB +`%`"> </div>
									</div>
								</div>
							</div>
						</div>

					</div>
					<div class="col-12 col-md-6">

						<div class="janelaPartida" v-if="partida3 != null">
							<div class="row">
								<div class="col tituloQuadroPequeno">
									<i class="fas fa-futbol ml-1"></i> Jogo Seguinte
								</div>
							</div>
							<div class="row">
								<div class="col text-center">
									<div class="d-flex flex-wrap justify-content-center gap-1 mt-2">
										<div class="badge badge-secondary mb-1"><i class="fas fa-calendar-alt"></i>&nbsp; {{ partida3.dataHoraFmt.substring(0, 5) }} </div>
										<div class="badge badge-secondary mb-1"><i class="far fa-clock"></i>&nbsp; {{ partida3.dataHoraFmt.substring(6, 8) }}h </div>
										<div class="badge badge-secondary mb-1 text-truncate" style="max-width: 150px;"><i class="fas fa-map-marker-alt"></i>&nbsp; {{ partida3.local }}</div>
									</div>
								</div>
							</div>
							<div class="row m-2 mt-2">
								<div class="col-4 text-center">
									<img width="20" class="mb-1" :src="partida3.selecaoA.imagem">
									<div class="font-weight-bold fonte-pequena text-truncate">{{partida3.selecaoA.nome}}</div>
								</div>
								<div class="col-4 text-center font-weight-bold fonte-pequena d-flex align-items-center justify-content-center">
									x
								</div>
								<div class="col-4 text-center">
									<img width="20" class="mb-1" :src="partida3.selecaoB.imagem">
									<div class="font-weight-bold fonte-pequena text-truncate">{{partida3.selecaoB.nome}}</div>
								</div>
							</div>
							<div class="row">
								<div class="col text-center">
									<button type="button" @click="detalharPartida(partida3.id)"
											class="btn btn-outline-secondary btn-sm">
										<i class="fas fa-eye mr-1"></i> Ver Partida
									</button>
								</div>
							</div>
							<div class="row m-2">
								<div class="col-4">
									<div class="font-weight-bold fonte-minima" :style="`color: `+ partida3.selecaoA.cor +`;`"> {{ partida3.aposta.porcSelecaoA }}% ({{partida3.aposta.numSelecaoA}}) </div>
								</div>
								<div class="col-4">
									<div class="text-center font-weight-bold fonte-minima" style="color: #4d4d4a;"> {{ partida3.aposta.porcEmpate }}% ({{partida3.aposta.numEmpate}}) </div>
								</div>
								<div class="col-4">
									<div class="text-right font-weight-bold fonte-minima" :style="`color: `+ partida3.selecaoB.cor +`;`"> {{ partida3.aposta.porcSelecaoB }}% ({{partida3.aposta.numSelecaoB}}) </div>
								</div>
							</div>
							<div class="row m-2">
								<div class="col">
									<div class="row">
										<div class="barraPorcentagem" :style="`background-color: `+ partida3.selecaoA.cor +`; width: `+ partida3.aposta.porcSelecaoA +`%`"> </div>
										<div class="barraPorcentagem" :style="`background-color: #a4a4a2; width: `+ partida3.aposta.porcEmpate +`%`"> </div>
										<div class="barraPorcentagem" :style="`background-color: `+ partida3.selecaoB.cor +`; width: `+ partida3.aposta.porcSelecaoB +`%`"> </div>
									</div>
								</div>
							</div>
						</div>

					</div>
				</div>

			</div>
			<div class="col-12 col-lg-4 order-2 order-lg-2 mb-3">
				
				<div class="quadroRanking">
					<div class="col-12 tituloQuadroPequeno font-weight-bold pt-2">
						<i class="fas fa-star mr-1"></i> Ranking atual
					</div>
					<div class="col-12 mt-2 font-weight-bold fonte-media ranking-scroll">
						
						<div class="row ml-1 descricaoRanking" style="margin-left: -7px !important;">
							<div class="col-11 text-left">

								<div class="row p-1 mt-1 colocacaoRanking"
										:class="(index <= 5) ? 'colocacaoRanking' : 'colocacaoSemRanking'"
										v-for="(rank, index) in ranking" :key="rank.usuario.id">
									<el-tooltip :content="'Nível: '+ rank.usuario.nivelDescricao" placement="top" effect="dark">
										<div class="col-1 ml--1 clickable" @click.native="paginaUsuario(rank.usuario.id)"
											:class="rank.usuario.nivel ? 'fundo-' + rank.usuario.nivel.toLowerCase().replace('_', '-') : ''">
											<img class="avatarRedondo" :class="rank.usuario.nivel ? 'borda-' + rank.usuario.nivel.toLowerCase().replace('_', '-') : ''" width="25" :src="rank.usuario.avatar">
										</div>
									</el-tooltip>
									<div class="col alinhaVert font-weight-bold" style="min-width:0">
										<user-name-badges
											:nome="(index+1) + '. ' + rank.usuario.nome"
										:badges="rank.badges || []"
											class="clickable"
											@click.native="paginaUsuario(rank.usuario.id)"
										/>
									</div>
									<div>
										{{ rank.pontuacao }} pts 
										<i v-if="rank.posicaoAnterior != 999" :class="(rank.posicaoAnterior > (index+1)) ? 'fas fa-angle-up text-success' : (rank.posicaoAnterior < (index+1)) ? 'fas fa-angle-down text-danger' : 'fas fa-minus'"></i>
										<span v-if="jogoAoVivo"> &nbsp; ( +{{rank.pontuacaoProvisoria}} )</span> 
									</div>
								</div>

							</div>
						</div>
					</div>
				</div>

			</div>
		</div>
		
		<div class="row mt-3">
			<div class="col-12">

				<hooper :itemsToShow="itemsToShowGrupos" :infiniteScroll="true" :autoPlay="true" :playSpeed="3000" class="hooper-grupos">
					<slide 
							v-for="c in classificacao" :key="c.grupo">
						<div class="row m-1">
							<div class="col tabelaGrupo">

								<table width="100%" style="">
									<tr class="font-weight-bold text-center"><td width="50%" class="text-left">Grupo {{ c.grupo }}</td><td width="6%">P</td><td width="6%">J</td><td width="6%">V</td><td width="6%">E</td><td width="6%">D</td><td width="6%">GP</td><td width="6%">GC</td><td width="6%">S</td><td width="6%">%</td></tr>
									<tr class="linhaGrupo text-center"
										:class="(index <= 1) ? 'colocacaoRanking' : 'colocacaoSemRanking'"
											v-for="(pontuacao, index) in c.listaClassificacao" :key="pontuacao.selecao.id">
										<td class="font-weight-bold alinhaVert text-left"> <img class="ml-2 mr-1" width="20" :src="pontuacao.selecao.imagem"> {{ pontuacao.selecao.nome }}</td>
										<td class="font-weight-bold">{{pontuacao.pontos}}</td><td>{{pontuacao.partidas}}</td><td>{{pontuacao.vitoria}}</td><td>{{pontuacao.empate}}</td><td>{{pontuacao.derrota}}</td><td>{{pontuacao.golspro}}</td><td>{{pontuacao.golscontra}}</td><td>{{pontuacao.saldogols}}</td><td>{{ (pontuacao.aproveitamento == null) ? "-" : pontuacao.aproveitamento}}</td>
									</tr>
								</table>

							</div>
						</div>
					</slide>

					<hooper-navigation slot="hooper-addons"></hooper-navigation>
				</hooper>				
				
			</div>
		</div>

    </div>
</template>
<script>
import { Hooper, Slide, Navigation as HooperNavigation } from 'hooper';
import 'hooper/dist/hooper.css';

export default {
	name: 'HomeDurante',
	components: {
		Hooper,
		Slide,
		HooperNavigation
	},
	created(){
		this.carregarDados();
	},
	data() {
		return {
			notificacao: null,
			partida1: null,
			partida2: null,
			partida3: null,
            jogoAoVivo: false,
			ranking: [],
			classificacao: [],
			partidasAnteriores: [],
			windowWidth: window.innerWidth
		}
	},
	computed: {
		itemsToShowGrupos() {
			return this.windowWidth < 768 ? 1 : 2;
		},
		classePartidaAnterior() {
			const classesPorQuantidade = {
				1: 'col-sm-12',
				2: 'col-sm-6',
				3: 'col-sm-4'
			};

			return classesPorQuantidade[this.partidasAnteriores.length] || 'col-sm-4';
		}
	},
	mounted() {
		window.addEventListener('resize', this.handleResize);
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.handleResize);
	},
	methods: {
		handleResize() {
			this.windowWidth = window.innerWidth;
		},
		carregarDados() {
			this.$clubApi.get("/configuracao/jogo/aovivo").then((response) => {
				this.jogoAoVivo = (response.data.object > 0);
			}) .catch((error) => {
				this.$notify({type: 'warning', message: error.response.data.msg})
			}).finally(() =>{
				this.carregarNotificacaoSorteada();
				NProgress.done();
			});
			this.carregarPartidas();
			this.carregarPartidasAnteriores();
			this.carregarRanking();
			this.carregarGrupos();
		},
		carregarPartidas() {
			this.$clubApi.get("/home/durante/partidas/otimizado").then((response) => {
				this.partida1 = response.data.object.partida1;
				this.partida2 = response.data.object.partida2;
				this.partida3 = response.data.object.partida3;
			}) .catch((error) => {
				this.$notify({type: 'warning', message: error.response.data.msg})
			}).finally(() =>{
				NProgress.done();
			})
		},
		carregarPartidasAnteriores() {
			this.$clubApi.get("/home/durante/partidas/anteriores").then((response) => {
				this.partidasAnteriores = response.data.object;
			}) .catch((error) => {
				this.$notify({type: 'warning', message: error.response.data.msg})
			}).finally(() =>{
				NProgress.done();
			})
		},
		carregarRanking() {
			this.$clubApi.get("/home/durante/ranking-completo").then((response) => {
				this.ranking = response.data.object;
			}) .catch((error) => {
				this.$notify({type: 'warning', message: error.response.data.msg})
			}).finally(() =>{
				NProgress.done();
			})
		},
		carregarGrupos() {
			this.$clubApi.get("/home/durante/grupo/otimizado").then((response) => {
				this.classificacao = response.data.object;
			}) .catch((error) => {
				this.$notify({type: 'warning', message: error.response.data.msg})
			}).finally(() =>{
				NProgress.done();
			})
		},
		detalharPartida(idPartida) {
            this.$router.push('/mundial/partida/'+ idPartida);
		},
        paginaUsuario(idUsuario) {
			location.href = '/meubolao/' + idUsuario;
		},
		carregarNotificacaoSorteada() {
		   this.$clubApi.get("/notificacao/sorteada").then((response) => {
		       this.notificacao = response.data.object;
		   }).catch((error) => {
		       console.warn("Erro ao buscar notificação: ", error);
		   });
		},
		irParaNotificacao() {
			this.$router.push('/bolao10/notificacao');
		},
		getEstiloNotificacao(tipo) {
		    const estilos = {
		        'SUBIU_NIVEL': { icone: 'fas fa-arrow-up', borda: '#6ea204', fundo: '#d4edda', fundoIcone: '#ECFFF1' },
		        'NOVO_LIDER_RANKING': { icone: 'fas fa-crown', borda: '#e0a800', fundo: '#fff0c3', fundoIcone: '#fbd86f' },
		        'NOVO_BADGE': { icone: 'fas fa-shield-alt', borda: '#007bff', fundo: '#cce5ff', fundoIcone: '#f0f7ff' },
		        'PARTIDA_FINALIZADA': { icone: 'far fa-check-circle', borda: '#17a2b8', fundo: '#dbf6fb', fundoIcone: '#FEFFFF' },
				'APOSTA_FINALIZADA': { icone: 'fas fa-fire-alt', borda: '#ac0404', fundo: '#ffc2c2', fundoIcone: '#FF7C7C' },
		        'MUDANCA_ARTILHARIA': { icone: 'fas fa-futbol', borda: '#fd7e14', fundo: '#ffe6d1', fundoIcone: '#ffc18e' },
				'PAGAMENTO_REALIZADO': { icone: 'fas fa-dollar-sign', borda: '#32CA8A', fundo: '#cdfbcc', fundoIcone: '#97FF94' },
		    };
		    return estilos[tipo] || { icone: 'fas fa-bell', borda: '#6c757d', fundo: '#e2e3e5' };
		}
	}
};
</script>
<style scoped>
/* Classes Utilitárias */
.home-durante-container {
	max-width: 100%;
	overflow-x: hidden;
}

.alinhaVert {
	margin: auto;
}

.text-truncate {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

/* Cards e Janelas */
.janelaPartida {
    border: 1px solid #d0d0d0;
    box-shadow: 0 2px 8px rgba(0,0,0,0.15);
    border-radius: 5px;
	background-color: #fcfcfc;
	padding: 10px;
}

.aovivo {
	border: 1px solid #58dd4c;
}

.quadroPequeno {
    border: 1px solid #a1bd9e;
    background-color: #d3f3d0;
    border-radius: 6px;
	padding: 10px;
}

.janelaPequena {
    border: 1px solid white;
    border-bottom: 1px solid #ccc;
    border-right: 1px solid #ccc;
    box-shadow: 0 0 4px rgba(0,0,0,.125),0 2px 4px rgba(0,0,0,.2);
    border-radius: 5px;
	background-color: #fCfCfC;
	padding: 10px;
}

.janelaNotificacao {
	border-radius: 5px;
	box-shadow: 0 .125rem .25rem rgba(0,0,0,.075)!important; 
	border: 1px solid #C0C0C0;
}

/* Tags e Badges */
.tagAoVivo {
    border: 1px solid #a50d0d;
    background-color: #fd3434;
	color: white;
    border-radius: 4px;
	font-weight: bold;
	padding: 3px 6px;
    font-size: 10px;
}

/* Tipografia Base */
.tituloJanelaPequena {
    font-size: 12px;
}

.tituloQuadroPequeno {
    font-size: 12px;
}

.fonte-grande {
    font-size: 32px;
}

.fonte-media {
    font-size: 18px;
}

.fonte-pequena {
	font-size: 14px;
}

.fonte-minima {
	font-size: 11px;
}

.fonte-placar {
	font-size: 28px;
}

.fonte-time {
	font-size: 16px;
}

/* Avatar */
.avatarRedondo {
    border-radius: 50%;
	object-fit: cover;
}

/* Barra de Apostas */
.barraPorcentagem {
	height: 4px;
    border-radius: 4px;
}

/* Ranking */
.quadroRanking {
    border: 1px solid #a1bd9e;
    background-color: #d3f3d0;
    border-radius: 6px;
	padding-top: 10px;
}

.descricaoRanking {
    font-size: 12px;
}

.ranking-scroll {
	max-height: 510px;
	overflow-y: auto;
	overflow-x: hidden;
}

.colocacaoRanking {
	border-left: 3px solid #96be92;
}

.colocacaoSemRanking {
	border-left: 3px solid #e7f3ef;
}

/* Tabelas de Grupos */	
.tabelaGrupo {
	font-size: 12px;
    background-color: #e7f3ef;
    border-radius: 6px;
	margin: 5px;
	padding: 10px;
	overflow-x: auto;
}

.tabelaGrupo table {
	min-width: 100%;
}

.linhaGrupo {
	border-bottom: 1px dashed #838383;
}

/* Hooper Carousel */
.hooper-grupos {
	height: auto;
	min-height: 180px;
}

/* Interações */
.clickable:hover {
    cursor: pointer;
    background-color: #e8f5e6;
	border-radius: 4px;
	transition: background-color 0.2s;
}

.fraseInicio {
	letter-spacing: 4px;
	font-size: 13px;
	font-style: italic;
}

/* Utilitário para botões mobile */
@media (max-width: 576px) {
	.btn-block-xs {
		width: 100%;
		display: block;
	}
}

/* Media Queries - Mobile First */
@media (max-width: 576px) {
	.fonte-grande {
		font-size: 24px;
	}
	
	.fonte-media {
		font-size: 16px;
	}
	
	.fonte-placar {
		font-size: 24px;
	}
	
	.fonte-time {
		font-size: 14px;
	}
	
	.fonte-pequena {
		font-size: 12px;
	}
	
	.fonte-minima {
		font-size: 10px;
	}
	
	.tabelaGrupo {
		font-size: 10px;
	}
	
	.ranking-scroll {
		max-height: 300px;
	}
	
	.quadroRanking {
		margin-bottom: 15px;
	}
	
	.hooper-grupos {
		min-height: 200px;
	}
}

/* Tablets */
@media (min-width: 577px) and (max-width: 991px) {
	.fonte-grande {
		font-size: 28px;
	}
	
	.fonte-media {
		font-size: 18px;
	}
	
	.fonte-placar {
		font-size: 26px;
	}
	
	.ranking-scroll {
		max-height: 350px;
	}
}

/* Desktop */
@media (min-width: 992px) {
	.fonte-grande {
		font-size: 32px;
	}
	
	.fonte-media {
		font-size: 21px;
	}
	
	.fonte-placar {
		font-size: 32px;
	}
	
	.ranking-scroll {
		max-height: 510px;
	}
}
</style>
